/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_N5Inputs */

const en_to_xml_ref_n5 = /** @type {(inputs: To_Xml_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters XML does not allow in a name become underscores.`)
};

const ko_to_xml_ref_n5 = /** @type {(inputs: To_Xml_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML이 이름에 허용하지 않는 문자는 밑줄이 됩니다.`)
};

const ja_to_xml_ref_n5 = /** @type {(inputs: To_Xml_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML が名前に許さない文字はアンダースコアになります。`)
};

/**
* | output |
* | --- |
* | "Characters XML does not allow in a name become underscores." |
*
* @param {To_Xml_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_n5 = /** @type {((inputs?: To_Xml_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_n5(inputs)
	if (locale === "ko") return ko_to_xml_ref_n5(inputs)
	return ja_to_xml_ref_n5(inputs)
});